/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { SelectFieldDisplay } from "./display";
import { SelectFieldEdit } from "./edit";

const SelectField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <SelectFieldDisplay />,
        editComponent: <SelectFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
SelectField.displayName = "SelectField";
export { SelectField };
